<template>
<div id="route-places">
  <div id="route-places-list" :class="{
      'dragging': isDragging,
      'live': route.live
      }">
    <Draggable 
      :disabled="!isOwner || route.live || locked"
      :list="placeList"
      tag="transition-group"
      item-key="id"
      ghost-class="ghost"
      @start="onMove"
      :move="checkMove"
      @end="onMoved"
      delay="25"
      animation="300"
      handle=".index"
      :component-data="{name:'route-places', type:'transition'}"
      >
      <template #item="{element, index}">
        <RoutePlace
          :route="route"
          :place="element"
          :placeIndex="index"
          :liveState="liveState"
          :isDragging="isDragging"
          :hideData="isDragging || route.loading"
          :canEdit="!locked"
        />
      </template>
    </Draggable>
  </div>
  <div id="no-places" class="no-print" v-if="route.places.length < 2">
    <img src="@/assets/no_stops.svg" />
    <div v-if="route.places.length == 0">
      <h3>Tilføj et stop til ruten</h3>
      <p>Din rute har ikke nogle stop endnu. Tilføj mindst to stop for at danne en rute. Søg efter en adresse i feltet herover eller importér adresser.</p>
      <AppButton color="primary" icon="upload_file" @click="openPlaceImporter" >Importér adresser</AppButton>
    </div>
    <div v-else>
      <h3>Tilføj endnu et stop til ruten</h3>
      <p>Tilføj mindst to stop for at danne en rute. Søg efter en adresse i feltet herover eller importér adresser.</p>
      <AppButton color="primary" icon="upload_file" @click="openPlaceImporter" >Importér adresser</AppButton>
    </div>
  </div>
</div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, PropType } from 'vue'
import Draggable from 'vuedraggable'
import RoutePlace from './RoutePlace.vue'
import { store } from '@/store'

import { validatePlaceIndex } from '@/api/tripply'
import { Route, Place, RouteLiveState } from '@/api/tripply/models'

export default defineComponent({
  name: 'RoutePlaces',
  props: {
    route: {
      type: Object as PropType<Route>,
      required: true
    },
    places: {
      type: Object as PropType<Place[]>,
      required: true
    },
    liveState: {
      type: [Object, Boolean] as PropType<false | RouteLiveState>,
      required: true
    },
    locked: Boolean
  },
  components: { Draggable, RoutePlace },
  setup(props) {
    const isOwner = computed(() => store.user.isOwner(props.route.id))
    const isDragging = ref(false)

    // Create non-reactive reference
    const placeList = computed(() => [...props.places])

    function checkMove(e: any) {
      const { index, futureIndex } = e.draggedContext
      return validatePlaceIndex(props.route, index, futureIndex)
    }
    function onMove() {
      isDragging.value = true      
    }
    function onMoved(e: any) {
      isDragging.value = false 
      store.route.changePlaceIndex(props.route.id, e.oldIndex, e.newIndex)
    }
    
    function openPlaceImporter() {
      store.modal.showModal('PlaceImporter', {routeId: props.route.id})
    }

    return { placeList, isOwner, props, onMove, checkMove, onMoved, isDragging, openPlaceImporter }
  }
})
</script>

<style lang="scss" scoped>
#route-places {
}
#route-places-list {
  position: relative;
  margin-bottom: 1rem;

  &:before {
    content: '';
    position: absolute;
    border-radius: 1rem;
    z-index: 0;
    left: 1.125rem;
    top: 1.5rem;
    bottom: 2.5rem;
    width: .25rem;
    background: var(--color-primary);
    opacity: 0.75;
    transition: transform .2s;
  }

  &.dragging:before {
    transform: scaleX(0.5);
  }
  &.live:before {
    width: .5rem;
    left: 1rem;
    background: var(--color-divider);
  }
}
.route-places-move {
  transition: transform .2s;
}

#no-places {
  text-align: center;
  img {
    margin: 1rem 0;
    width: 75%;
  }
}
</style>